var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
/* eslint-disable import/no-cycle */
import React from 'react';
import styled from '@empiriecom/module-components/utils/styled-components';
import cuid from 'cuid';
import filterTimeControl from '../../utils/filterTimeControl';
import Slider from '@empiriecom/module-components/Slider';
import ComponentRecognizer from '../ComponentRecognizer';
var StyledCarousel = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ",
    "\n  ",
    "\n"])), function (_a) {
    var fieldMargin = _a.fieldMargin;
    return fieldMargin ? "margin: " + fieldMargin + ";" : 'margin-bottom: 2rem;';
}, function (_a) {
    var fieldPadding = _a.fieldPadding;
    return fieldPadding ? "padding: " + fieldPadding + ";" : 'padding: 0;';
});
var Carousel = function (_a) {
    var contentData = _a.contentData;
    var _b = contentData.field_autoplay, autoplay = _b === void 0 ? false : _b, _c = contentData.field_infinite, infinite = _c === void 0 ? false : _c, _d = contentData.field_speed, speed = _d === void 0 ? 500 : _d, _e = contentData.field_margin, margin = _e === void 0 ? '0' : _e, _f = contentData.field_padding, padding = _f === void 0 ? '0' : _f, _g = contentData.field_slides_to_show, slidesToShow = _g === void 0 ? 1 : _g, _h = contentData.id, id = _h === void 0 ? cuid() : _h;
    var sliderConfig = {
        styleType: 'type1',
        autoplay: autoplay,
        infinite: infinite,
        speed: speed,
        slidesToShow: slidesToShow,
    };
    var sliderItemData = function (item) {
        return {
            content: [item],
        };
    };
    return (React.createElement(StyledCarousel, { className: "cms-slider-wrapper", "data-testid": "cms-slider", key: "cms-slider-" + id, fieldMargin: margin, fieldPadding: padding },
        React.createElement(Slider, { autoplay: sliderConfig.autoplay, infinite: sliderConfig.infinite, speed: sliderConfig.speed, styleType: sliderConfig.styleType, slidesToShow: sliderConfig.slidesToShow }, contentData.paragraph &&
            contentData.paragraph
                .filter(function (item) {
                return filterTimeControl(item);
            })
                .map(function (item) {
                var itemID = cuid();
                return (React.createElement(ComponentRecognizer, { content: sliderItemData(item).content, key: "cms-slider-" + itemID + "-" + item.id }));
            }))));
};
export default Carousel;
var templateObject_1;
//# sourceMappingURL=index.js.map